import { Component, Prop, h, Host, Element } from '@stencil/core';

@Component({
    tag: 'ti-product-synopsis',
    styleUrl: 'product-synopsis.scss',
    shadow: true
})
export class ProductSynopsis {

    private _dataLid: string;

    @Element() hostElement: HTMLTiProductSynopsisElement;

    /**
     * Default image if chipshot image not found.
     *
     * @type {string}
     * @memberof ProductSynopsis
     */
    @Prop() defaultImage: string;

    /**
     * URL for the chipshot.
     *
     * @type {string}
     * @memberof ProductSynopsis
     */
    @Prop() imageUrl: string;

    /**
     * URL for the product page.
     *
     * @type {string}
     * @memberof ProductSynopsis
     */
    @Prop() productUrl: string;

    /**
     * Property for specifying the vertical layout.
     *
     * @type {boolean}
     * @default false
     */
    @Prop() vertical: boolean = false;

    componentWillLoad() {
        this._dataLid = this.hostElement.getAttribute('data-lid');
    }

    render() {
        if (this.vertical) {
            return (
                <Host class="ti-product-synopsis-vertical">
                    {/* VERTICAL */}
                    <div class="ti-product-synopsis-container">
                        <slot name="new-badge" />
                        <div class="ti-product-synopsis-image">
                            <ti-image
                                src={this.imageUrl}
                                src-default={this.defaultImage}
                                href={this.productUrl}
                                target="_blank"
                                ratio="rectangle"
                                data-lid={this._dataLid + '_image'}
                            >
                            </ti-image>
                        </div>
                        <div class="ti-product-synopsis-details">
                            <slot name="product-family" />
                            <ti-titled-description compact>
                                <span slot="title" class="ti-product-synopsis-title">
                                    <slot name="product-link" />

                                    <slot name="product-status" />
                                </span>
                                <span slot="description"><slot name="description" /></span>
                            </ti-titled-description>
                            <slot name="bottom" />
                        </div>
                    </div>
                </Host >
            );
        }
        else {
            return (
                <Host class="ti-product-synopsis-horizontal">
                    <div class="ti-product-synopsis-container">
                        <div class="ti-product-synopsis-image">
                            <ti-image
                                src={this.imageUrl}
                                src-default={this.defaultImage}
                                href={this.productUrl}
                                target="_blank"
                                ratio="square"
                                data-lid={this._dataLid + '_image'}
                            >
                            </ti-image>
                        </div>
                        <div class="ti-product-synopsis-details">
                            <slot name="product-family" />
                            <ti-titled-description compact>
                                <span slot="title" class="ti-product-synopsis-title">
                                    <slot name="product-link" />
                                    <slot name="new-badge" />
                                    <slot name="product-status" />
                                </span>
                                <span slot="description"><slot name="description" /></span>
                            </ti-titled-description>
                            <slot name="comment" />
                            <slot name="bottom" />
                        </div>
                    </div>
                </Host>
            );
        }

    }
}
